import React from 'react';
import Redirect from '~/components/Redirect';
import { ROUTES } from '~/constants/ROUTES';
import { useMeQuery } from '~/generated/apollo';
import LoadingPage from '../LoadingPage';
export interface GuardAccountProps {
  children: React.ReactNode;
}
export const GuardAccount: React.FC<GuardAccountProps> = ({
  children
}: GuardAccountProps): React.ReactNode | React.ReactElement<GuardAccountProps> => {
  const {
    data,
    loading
  } = useMeQuery();
  if (loading) {
    return <LoadingPage />;
  }
  if (data && data.me) {
    return children;
  }
  return <Redirect pathname={ROUTES.SIGNIN} query={{
    returnUrl: window.location.pathname
  }} data-sentry-element="Redirect" data-sentry-component="GuardAccount" data-sentry-source-file="index.tsx" />;
};
export default GuardAccount;